import React from 'react'
import PropTypes from 'prop-types'
import FormField from './FormField'
import { COMMON_FORM_FIELD_PROPS, FORM_FIELD_CONTROL_PROPS, InputType } from './FORM_FIELD_PROP_TYPES'

const ControlledFormField = ({
  inputType = InputType.Text,
  id,
  label = '',
  attachedLabel,
  options,
  placeholder,
  detail,
  maxLength,
  minLength,
  className,
  onChange,
  onBlur,
  value,
  error,
  disabled,
}) => {

  return <FormField
    id={id}
    label={label}
    inputType={inputType}
    attachedLabel={attachedLabel}
    options={options}
    onChange={onChange}
    onBlur={onBlur}
    value={value}
    invalid={!!error}
    error={error}
    disabled={disabled}
    placeholder={placeholder}
    detail={detail}
    maxLength={maxLength}
    minLength={minLength}
    className={className}
  />

}

ControlledFormField.propTypes = {
  ...COMMON_FORM_FIELD_PROPS,
  ...FORM_FIELD_CONTROL_PROPS,
  /** A form field can be disabled by the parent in lieu of the redux form field disabled property */
  disabled: PropTypes.bool,
}

export default ControlledFormField